(function ($) {
    'use strict';

    const SELECTORS = {
        block: '.testimonials',
        slider: '.testimonials__slider',
        track: '.testimonials__track',
        slide: '.testimonials__slide',
        pagination: '.testimonials__pagination',
        bullet: '.testimonials__bullet'
    };

    const MOBILE_BREAKPOINT = 768;
    const SWIPE_THRESHOLD = 30;
    const TRANSITION_DURATION = 450;

    function initTestimonials($block) {

        const $slider = $block.find(SELECTORS.slider);
        const $track = $block.find(SELECTORS.track);
        const $pagination = $block.find(SELECTORS.pagination);

        if (!$slider.length || !$track.length) {
            return;
        }

        let $slides = $track.find(SELECTORS.slide);

        const totalSlides = $slides.length;

        if (!totalSlides) {
            return;
        }

        /*
         * --------------------------------------------------
         * State
         * --------------------------------------------------
         */

        let currentIndex = 0;

        let visibleSlides = 2;

        let slideWidth = 0;
        let trackGap = 0;
        let slideStep = 0;

        let maxIndex = 0;

        let cloneCount = 0;

        let isDragging = false;

        let startX = 0;
        let currentX = 0;
        let startTime = 0;

        let resizeTimer = null;

        let isLoopingForward = false;

        /*
         * --------------------------------------------------
         * Helpers
         * --------------------------------------------------
         */

        function getVisibleSlides() {
            return window.innerWidth <= MOBILE_BREAKPOINT ? 1 : 2;
        }

        function getGap() {

            const styles = window.getComputedStyle($track[0]);

            let gap = parseFloat(styles.columnGap);

            if (isNaN(gap)) {
                gap = parseFloat(styles.gap);
            }

            return isNaN(gap) ? 0 : gap;
        }

        function isLoopEnabled() {
            return $block.attr('data-loop') === 'true';
        }

        /*
         * --------------------------------------------------
         * Remove clones
         * --------------------------------------------------
         */

        function removeClones() {

            $track.find('.testimonials__slide.is-clone').remove();

            $slides = $track.find(SELECTORS.slide);

            cloneCount = 0;
        }

        /*
         * --------------------------------------------------
         * Create clones
         * --------------------------------------------------
         */

        function createClones() {

            removeClones();

            if (!isLoopEnabled() || totalSlides <= visibleSlides) {
                cloneCount = 0;
                return;
            }

            cloneCount = Math.min(visibleSlides, totalSlides);

            /*
             * ----------------------------------------------
             * PREPEND LAST SLIDES
             * ----------------------------------------------
             */

            for (let i = totalSlides - cloneCount; i < totalSlides; i++) {

                const $clone = $slides.eq(i).clone(false, false);

                $clone.addClass('is-clone').attr('aria-hidden', 'true');

                $track.prepend($clone);
            }

            /*
             * ----------------------------------------------
             * APPEND FIRST SLIDES
             * ----------------------------------------------
             */

            for (let i = 0; i < cloneCount; i++) {

                const $clone = $slides.eq(i).clone(false, false);

                $clone.addClass('is-clone').attr('aria-hidden', 'true');

                $track.append($clone);
            }

            $slides = $track.find(SELECTORS.slide);
        }

        /*
         * --------------------------------------------------
         * Dimensions
         * --------------------------------------------------
         */

        function updateDimensions() {

            visibleSlides = getVisibleSlides();

            trackGap = getGap();

            const sliderWidth = $slider.innerWidth();

            if (visibleSlides === 2) {
                slideWidth = (sliderWidth - trackGap) / 2;
            } else {
                slideWidth = sliderWidth;
            }

            $slides.css('flex-basis', slideWidth + 'px');

            slideStep = slideWidth + trackGap;

            maxIndex = Math.max(0, totalSlides - visibleSlides);
        }

        /*
         * --------------------------------------------------
         * Pagination
         * --------------------------------------------------
         */

        function getPaginationCount() {

            if (totalSlides === 1) {
                return 1;
            }

            if (totalSlides === 2 && visibleSlides === 2) {
                return 1;
            }

            if (totalSlides === 2 && visibleSlides === 1) {
                return 2;
            }

            if (isLoopEnabled()) {
                return totalSlides;
            }

            return maxIndex + 1;
        }

        function buildPagination() {

            $pagination.empty();

            const paginationCount = getPaginationCount();

            for (let index = 0; index < paginationCount; index++) {

                const $bullet = $('<button>', {
                    type: 'button',
                    class: 'testimonials__bullet', 'aria-label': 'Go to testimonial ' + (index + 1)
                });

                $bullet.attr('data-index', index);

                $pagination.append($bullet);
            }

            if (paginationCount > 0) {
                $pagination.show();
            } else {
                $pagination.hide();
            }
        }

        function updatePagination() {

            const $bullets = $pagination.find(SELECTORS.bullet);

            $bullets.removeClass('is-active').removeAttr('aria-current');

            if (!$bullets.length) {
                return;
            }

            let activeIndex = currentIndex;

            if (totalSlides === 1) {
                activeIndex = 0;
            }

            else if (totalSlides === 2 && visibleSlides === 2) {
                activeIndex = 0;
            }

            else if (isLoopEnabled() && visibleSlides === 2 && isLoopingForward) {
                activeIndex = 0;
            }

            /*
             * ----------------------------------------------
             * SAFETY
             * ----------------------------------------------
             */

            activeIndex = Math.max(0, Math.min(activeIndex, $bullets.length - 1));

            $bullets.eq(activeIndex).addClass('is-active').attr('aria-current', 'true');
        }

        /*
         * --------------------------------------------------
         * Track position
         * --------------------------------------------------
         */

        function getTrackIndex() {

            if (isLoopEnabled() && cloneCount > 0) {
                return currentIndex + cloneCount;
            }

            return currentIndex;
        }

        function updateTransform(animate = true) {

            if (!slideStep) {
                return;
            }

            if (!animate) {
                $track.css('transition', 'none');
            } else {
                $track.css('transition', '');
            }

            const trackIndex = getTrackIndex();

            const translateX = trackIndex * slideStep;

            $track.css('transform', 'translate3d(-' + translateX + 'px, 0, 0)');

            if (!animate) {
                $track[0].offsetHeight;
                $track.css('transition', '');
            }

            updatePagination();
        }

        /*
         * --------------------------------------------------
         * Mode
         * --------------------------------------------------
         */

        function updateMode() {

            if (totalSlides === 1) {

                $block.removeClass('is-slider').addClass('is-static');

                currentIndex = 0;

                isLoopingForward = false;

                $track.css('transform', 'none');

                buildPagination();
                updatePagination();

                return;
            }

            if (totalSlides === 2 && visibleSlides === 2) {

                $block.removeClass('is-slider').addClass('is-static');

                currentIndex = 0;

                isLoopingForward = false;

                $track.css('transform', 'none');

                buildPagination();
                updatePagination();

                return;
            }

            $block.removeClass('is-static').addClass('is-slider');

            buildPagination();
        }

        /*
         * --------------------------------------------------
         * Refresh
         * --------------------------------------------------
         */

        function refresh(animate = false) {

            removeClones();

            visibleSlides = getVisibleSlides();

            updateMode();

            if (!$block.hasClass('is-slider')) {
                return;
            }

            createClones();

            updateDimensions();

            if (currentIndex > maxIndex) {
                currentIndex = maxIndex;
            }

            isLoopingForward = false;

            updateTransform(animate);
        }

        /*
         * --------------------------------------------------
         * Navigation
         * --------------------------------------------------
         */

        function goTo(index, animate = true) {

            if (!$block.hasClass('is-slider')) {
                return;
            }

            const loop = isLoopEnabled();

            /*
             * ----------------------------------------------
             * NON LOOP
             * ----------------------------------------------
             */

            if (!loop) {

                currentIndex = Math.max(0, Math.min(index, maxIndex));

                isLoopingForward = false;

                updateTransform(animate);

                return;
            }

            /*
             * ----------------------------------------------
             * LOOP FORWARD
             * ----------------------------------------------
             */

            if (index >= totalSlides) {

                isLoopingForward = true;

                currentIndex = totalSlides;

                updateTransform(true);

                setTimeout(function () {

                    currentIndex = 0;

                    isLoopingForward = false;

                    updateTransform(false);

                }, TRANSITION_DURATION);

                return;
            }

            /*
             * ----------------------------------------------
             * LOOP BACKWARD
             * ----------------------------------------------
             */

            if (index < 0) {

                currentIndex = -1;

                updateTransform(true);

                setTimeout(function () {

                    currentIndex = totalSlides - 1;

                    isLoopingForward = false;

                    updateTransform(false);

                }, TRANSITION_DURATION );

                return;
            }

            /*
             * ----------------------------------------------
             * NORMAL NAVIGATION
             * ----------------------------------------------
             */

            currentIndex = index;

            isLoopingForward = false;

            updateTransform(animate);
        }

        function next() {
            goTo(currentIndex + 1);
        }

        function previous() {
            goTo(currentIndex - 1);
        }

        /*
         * --------------------------------------------------
         * Bullet click
         * --------------------------------------------------
         */

        $pagination.on('click', SELECTORS.bullet, function () {

            const index = parseInt( $(this).attr('data-index'), 10 );

            if (isNaN(index)) {
                return;
            }

            if (totalSlides === 2 && visibleSlides === 2) {

                currentIndex = 0;

                isLoopingForward = false;

                updatePagination();

                return;
            }

            if (isLoopEnabled() && index === 0) {

                currentIndex = 0;

                isLoopingForward = false;

                updateTransform(true);

                return;
            }

            goTo(index);
        });

        /*
         * --------------------------------------------------
         * Touch start
         * --------------------------------------------------
         */

        $slider.on('touchstart', function (event) {

            if (!$block.hasClass('is-slider')) {
                return;
            }

            const touch = event.originalEvent.touches[0];

            startX = touch.clientX;

            currentX = startX;

            startTime = Date.now();

            isDragging = true;

            $slider.addClass('is-dragging');

            $track.css('transition', 'none');
        });

        /*
         * --------------------------------------------------
         * Touch move
         * --------------------------------------------------
         */

        $slider.on('touchmove', function (event) {

            if (!isDragging) {
                return;
            }

            const touch = event.originalEvent.touches[0];

            currentX = touch.clientX;

            const diff = currentX - startX;

            if (Math.abs(diff) > 10) {
                event.preventDefault();
            }

            const trackIndex = getTrackIndex();

            const translateX = -(trackIndex * slideStep) + diff;

            $track.css('transform', 'translate3d(' + translateX + 'px, 0, 0)');
        });

        /*
         * --------------------------------------------------
         * Touch end
         * --------------------------------------------------
         */

        $slider.on('touchend touchcancel', function () {

            if (!isDragging) {
                return;
            }

            isDragging = false;

            $slider.removeClass('is-dragging');

            const diff = currentX - startX;

            const elapsed = Date.now() - startTime;

            $track.css('transition', '');

            const isFastSwipe = elapsed < 300 && Math.abs(diff) > 15;

            const shouldChange = Math.abs(diff) >= SWIPE_THRESHOLD || isFastSwipe;

            if (!shouldChange) {

                updateTransform(true);

                return;
            }

            if (diff < 0) {
                next();
            } else {
                previous();
            }
        });

        /*
         * --------------------------------------------------
         * Mouse drag
         * --------------------------------------------------
         */

        $slider.on('mousedown', function (event) {

            if (!$block.hasClass('is-slider') || event.button !== 0) {
                return;
            }

            startX = event.clientX;

            currentX = startX;

            startTime = Date.now();

            isDragging = true;

            $slider.addClass('is-dragging');

            $track.css('transition', 'none');

            event.preventDefault();
        });

        $(document).on('mousemove.testimonials', function (event) {

            if (!isDragging || !$slider.hasClass('is-dragging')) {
                return;
            }

            currentX = event.clientX;

            const diff = currentX - startX;

            const trackIndex = getTrackIndex();

            const translateX = -(trackIndex * slideStep) + diff;

            $track.css('transform', 'translate3d(' + translateX + 'px, 0, 0)');
        });

        $(document).on('mouseup.testimonials', function () {

            if (!isDragging || !$slider.hasClass('is-dragging')) {
                return;
            }

            isDragging = false;

            $slider.removeClass('is-dragging');

            const diff = currentX - startX;

            const elapsed = Date.now() - startTime;

            $track.css('transition', '');

            const isFastSwipe = elapsed < 300 && Math.abs(diff) > 15;

            const shouldChange = Math.abs(diff) >= SWIPE_THRESHOLD || isFastSwipe;

            if (!shouldChange) {

                updateTransform(true);

                return;
            }

            if (diff < 0) {
                next();
            } else {
                previous();
            }
        });

        /*
         * --------------------------------------------------
         * Resize
         * --------------------------------------------------
         */
        $(window).on('resize.testimonials', function () {

            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(function () {
                refresh(false);
            }, 150 );
        });

        refresh(false);
    }

    /*
     * ------------------------------------------------------
     * Initialise all Testimonials blocks
     * ------------------------------------------------------
     */
    function initAllTestimonials() {

        $(SELECTORS.block).each(
            function () {

                const $block = $(this);

                if ($block.data('testimonials-initialized')) {
                    return;
                }

                $block.data('testimonials-initialized', true);

                initTestimonials($block);
            }
        );
    }

    $(function () {
        initAllTestimonials();
    });

})(jQuery);